<template>
  <section class="hp-employer hp-animate">
    <div class="container">
      <div class="hp-employer__inner">
        <div class="hp-employer__copy">
          <p class="hp-employer__label">Employer zone</p>
          <h2 class="hp-employer__title">Hiring freshers? Post a job free.</h2>
          <p class="hp-employer__text">Recruit from India's largest pool of candidate video profiles.</p>
          <div class="hp-employer__actions">
            <a href="/recruit/post-job" class="hp-btn hp-btn--light">Post a job</a>
            <a href="/recruit/login" class="hp-btn hp-btn--outline-light">Employer login</a>
          </div>
        </div>
        <div class="hp-employer__visual hp-hide-mobile">
          <img
            :src="$S3_url + '/Assets/images/employer-img.svg'"
            alt=""
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeEmployerBanner',
};
</script>
